<template>
  <div>
    <portal
      v-if="hasChatMessengerId"
      target-el="#chat-icon">
      <MessengerIcon />
    </portal>
    <portal
      v-if="hasNotificationControl"
      target-el="#notification-panel-mount">
      <NotificationsPanel />
    </portal>
    <portal :target-el="`#${portalId}`">
      <v-app>
        <component
          :is="viewComponent"
          v-show="!isComponentLoading"
          v-bind="componentProps" />
      </v-app>
    </portal>
  </div>
</template>

<script>
import { importView } from "@/themes";
import MessengerIcon  from "@/views/company/messageApp/messengerIcon"
import NotificationsPanel from '@/views/notifications/NotificationsPanel.vue'

export default {
  name       : "PortalWrapper",
  components : {
    MessengerIcon,
    NotificationsPanel,
  },
  props : {
    view : { type : String, required : true },

    portalId : { type : String, required : true, default : "" },

    componentProps : { type : Object, default : () => ({}) }
  },

  data() {
    return {
      isComponentLoading : true,
      viewComponent      : null
    };
  },
  computed : {
    hasChatMessengerId(){
      return document.getElementById("chat-icon")
    },
    hasNotificationControl(){
      return document.getElementById('notification-panel-mount')
    },
  },
  watch : {
    // @TODO not sure what this is doing
    "$route.path" : {
      immediate : true,
      handler   : function() {
        return this.loadView();
      }
    }
  },

  methods : {
    loadView() {
      this.isComponentLoading = true;
      return importView(this.view)
        .then(c => {
          this.viewComponent = c.default;
        })
       
        .catch(e => {
          // eslint-disable-next-line no-console
          console.log(e)
        })
        .finally(() => (this.isComponentLoading = false));
    }
  }
};
</script>
